module.exports = __webpack_public_path__ + "static/img/video1.bc17ee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video1.jpg
// module id = tspg
// module chunks = 10